/* eslint-disable */
export default {
  Inbound: '着信',
  Outbound: '発信',
  log: 'ログ',
  save: '保存して新規作成',
  discard: '破棄して新規作成',
  hangup: '通話終了',
  reject: 'ボイスメールへ',
  saveDraftAndCreateNewLog: '下書きを保存して新しい通話ログを作成',
} as const;

// @key: @#@"Inbound"@#@ @source: @#@"Inbound"@#@
// @key: @#@"Outbound"@#@ @source: @#@"Outbound"@#@
// @key: @#@"log"@#@ @source: @#@"Log"@#@
// @key: @#@"save"@#@ @source: @#@"Save and new"@#@
// @key: @#@"discard"@#@ @source: @#@"Discard and new"@#@
// @key: @#@"hangup"@#@ @source: @#@"Hangup"@#@
// @key: @#@"reject"@#@ @source: @#@"To Voicemail"@#@
// @key: @#@"saveDraftAndCreateNewLog"@#@ @source: @#@"Save draft and create new call log"@#@
